import type { FC } from "react";
import { useMarketBuilderServices } from "../../CustomHooks/useMarketBuilderServices";
import * as utils from "app/components/filters-bar/utils";
import { CountryFilter as CountryFilterSelector } from "app/components/filters-bar/country-filter/CountryFilter";
import { CountriesAutocompleteContainer, StyledCountryFilterContainer, StyledHeader } from "./styledComponents";
import { InfoTooltip } from "@similarweb/ui-components";
import { renderButtonComponent } from "app/components/filters-bar/country-filter/renderButtonComponent";
import type { ICountryObject } from "app/services/CountryService";

interface ICountryFilterProps {
    selectedCountry?: ICountryObject;
    onChangeSelectedCountry?: (itemId: number) => void;
}

export const CountryFilter: FC<ICountryFilterProps> = (props) => {
    const availableCountries = utils.getCountries();
    const { selectedCountry = availableCountries[0], onChangeSelectedCountry } = props;
    const services = useMarketBuilderServices();
    const { translate } = services;
    const headerText = translate("country.research.market.builder.header");

    return (
        <StyledCountryFilterContainer>
            <StyledHeader>
                {headerText}
                <InfoTooltip info={translate("country.research.market.builder.tooltip.info")} />
            </StyledHeader>
            <CountriesAutocompleteContainer>
                <CountryFilterSelector
                    width={300}
                    height={40}
                    dropdownPopupWidth={243}
                    availableCountries={availableCountries}
                    selectedCountryIds={{ [selectedCountry.id]: true }}
                    changeCountry={onChangeSelectedCountry}
                    dropdownPopupHeight={190}
                    cssClassContainer={"market-builder-filter"}
                    renderButtonComponent={renderButtonComponent}
                />
            </CountriesAutocompleteContainer>
        </StyledCountryFilterContainer>
    );
};
